import type { AccordionTabProps } from '../Accordion'

const faqData: Array<AccordionTabProps> = [
  {
    id: 'faq-poi-why-upload',
    title: 'Why do I have to upload proof of income?',
    content:
      'In order to process your application and so that a decision may be provided to you, you will need to upload proof of income documentation. We may be required to review this documentation to assist in the determination of your ability to make minimum payments each month. If you do not have proof of income documentation or you do not wish to provide such documentation, you can safely exit the application by closing your browser.',
  },
  {
    id: 'faq-poi-can-i-fax',
    title: 'Can I fax or mail my proof of income?',
    content:
      'You will need to upload this documentation via our website. We cannot process income documentation via fax or mail at this time.',
  },
]

export default faqData
